import { Routes, Route as RouteItem, useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import RippleButton from "../components/common/RippleButton";
import Menu from "../features/menu/Menu";
import Rights from "../features/rights/Rights";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import { PrivateLoginRoute, PrivateRoute } from "./PrivateRoute";
import Inquiry from "../features/inquiry/Inquiry";
// import CreateInquiry from "../features/inquiry/CreateInquiry";
import Testimonial from "../features/testimonial/Testimonial";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
import CMS from "../features/cms/CMS";
import CreateCMS from "../features/cms/CreateCMS";
import LoginNew from "../features/login/Login";
import Setting from "../features/setting/Setting";
import Dashboard from "../features/dashboard/Dashboard";
import Country from "../features/country/Country";
import State from "../features/state/State";
import City from "../features/city/City";
import PropertyTypes from "../features/propertytype/PropertyTypes";
import PropertyStatus from "../features/propertystatus/PropertyStatus";
import Areas from "../features/area/Areas";
import Service from "../features/services/Service";
import CreateService from "../features/services/CreateService";
import Project from "../features/project/Project";
import CreateProject from "../features/project/CreateProject";
import Research from "../features/research/Research";
import CreateResearch from "../features/research/CreateResearch";
import Videos from "../features/video/Videos";

const MainRouter = () => {
  const navigate = useNavigate();
  return (
    <Routes>
      <RouteItem
        path="login"
        element={
          <PrivateLoginRoute>
            <LoginNew />
          </PrivateLoginRoute>
        }
      />
      <RouteItem
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <RouteItem index={true} element={<Dashboard />} />
        <RouteItem path="menu" element={<Menu />} />
        <RouteItem path="rights" element={<Rights />} />
        <RouteItem path="country" element={<Country />} />
        <RouteItem path="state" element={<State />} />
        <RouteItem path="city" element={<City />} />
        <RouteItem path="testimonial" element={<Testimonial />} />
        <RouteItem path="video" element={<Videos />} />

        <RouteItem path="user" element={<User />} />
        <RouteItem path="user/create" element={<CreateUser />} />
        <RouteItem path="user/edit" element={<CreateUser />} />

        <RouteItem path="banner" element={<Banner />} />
        <RouteItem path="banner/create" element={<CreateBanner />} />
        <RouteItem path="banner/edit" element={<CreateBanner />} />

        <RouteItem path="seotag" element={<SeoTag />} />
        <RouteItem path="seotag/create" element={<CreateSeoTag />} />
        <RouteItem path="seotag/edit" element={<CreateSeoTag />} />

        <RouteItem path="blog" element={<Blog />} />
        <RouteItem path="blog/create" element={<CreateBlog />} />
        <RouteItem path="blog/edit" element={<CreateBlog />} />

        <RouteItem path="faq" element={<FAQ />} />
        <RouteItem path="faq/create" element={<CreateFAQ />} />
        <RouteItem path="faq/edit" element={<CreateFAQ />} />

        <RouteItem path="service" element={<Service />} />
        <RouteItem path="service/create" element={<CreateService />} />
        <RouteItem path="service/edit" element={<CreateService />} />

        <RouteItem path="project" element={<Project />} />
        <RouteItem path="project/create" element={<CreateProject />} />
        <RouteItem path="project/edit" element={<CreateProject />} />

        <RouteItem path="research" element={<Research />} />
        <RouteItem path="research/create" element={<CreateResearch />} />
        <RouteItem path="research/edit" element={<CreateResearch />} />

        <RouteItem path="cms" element={<CMS />} />
        <RouteItem path="cms/edit" element={<CreateCMS />} />
        <RouteItem path="cms/create" element={<CreateCMS />} />
        <RouteItem path="usertype" element={<UserType />} />
        <RouteItem path="usertype/create" element={<CreateUserType />} />
        <RouteItem path="usertype/edit" element={<CreateUserType />} />
        <RouteItem path="inquiry" element={<Inquiry />} />
        <RouteItem path="inquiries" element={<Inquiry />} />
        <RouteItem path="setting" element={<Setting />} />
        <RouteItem path="propertytype" element={<PropertyTypes />} />
        <RouteItem path="propertystatus" element={<PropertyStatus />} />
        <RouteItem path="area" element={<Areas />} />
      </RouteItem>
      <RouteItem
        path="*"
        element={
          <RippleButton
            onClick={() => navigate("/")}
            style={{ margin: "20px" }}
          >
            Back to Home
          </RippleButton>
        }
      />
    </Routes>
  );
};

export default MainRouter;
